import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-135" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-136" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-137" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-red-700 bg-red-50 text-neutral-900 font-bold text-xs sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-138" data-mp="3d21ty23jwspu">
            FIRE SERVICE INSTRUCTOR ATLAS
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-neutral-900 uppercase" data-id="element-139" data-mp="3j9agbasosm43">
            Solve <span className="text-red-700" data-id="element-140" data-mp="399b9bibx13tc">Months of Firefighter Training</span> Lesson
            Planning <span className="text-red-700" data-id="element-141" data-mp="3e8mt707kwpf5">in Just 5 Minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-142" data-mp="30gzwiz9q5evu">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-143" data-mp="2vietyt702j48" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-144" data-mp="2lkqz839e9bm2">
          <p className="text-sm sm:text-lg md:text-xl text-neutral-800 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-145" data-mp="nbl4urpxgsdm">
            The Complete{' '}
            <span className="font-semibold text-neutral-900" data-id="element-146" data-mp="icromrj9an9r">
              6-in-1 Visual Firefighter Training & Reference System
            </span>{' '}
            — <span className="font-semibold text-neutral-900" data-id="element-147" data-mp="1b0nmw0oh4n8n">6 Professional Volumes</span> + 5
            Exclusive Instructor Bonuses, Designed to Help You Plan, Teach, Demonstrate & Assess
            With Confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-red-700 mb-5 sm:mb-7" data-id="element-148" data-mp="111erd3dyn0k6">
            100% VISUAL MAIN SYSTEM · READY-TO-TEACH MATERIAL · BEGINNER TO ADVANCED
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-149" data-mp="3ltqe5h5gv3vm">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-150" data-mp="3hrlk4hb3w58g">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-neutral-800/80 mb-3" data-id="element-151" data-mp="21b61vs3mqqk0">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-152" data-mp="2b1rb09gxjdh6">
                <CheckCircle size={14} className="text-red-700" data-id="element-153" data-mp="2g02kgj3bblyv" />
                <span className="font-medium" data-id="element-154" data-mp="2fziymrajkdfk">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-neutral-800/60" data-id="element-155" data-mp="2l0zyqkl7bvv3">
            6 Complete Volumes · 100% Visual Main Training System · 5 Professional Instructor Bonuses
          </p>
        </motion.div>
      </div>
    </section>;
}